/* HEADER */
const header = document.querySelector(".header");
const hero = document.querySelector(".hero");

const scrollOptions = {
  rootMargin: "-400px 0px 0px 0px",
};

/* change nav background on scroll */
if (hero === null) {
  header.classList.add("header-scrolled");
}

const scrollObserver = new IntersectionObserver((items) => {
  items.forEach((item) => {
    if (!item.isIntersecting) {
      header.classList.add("header-scrolled");
    } else if (header.classList.contains("header-scrolled")) {
      header.classList.remove("header-scrolled");
    }
  });
}, scrollOptions);

if (hero) {
  scrollObserver.observe(hero);
}

/* PRODUCT */
// title split
var titleSplit = document.querySelector("#prod-title-split");
var titleMain = document.querySelector("#prod-title-main");

if (titleSplit && titleMain) {
  var title = titleMain.innerText;
  if (title.slice(0, 14) === "Japan Inspired") {
    titleSplit.innerText = title.slice(0, 14);
    titleMain.innerText = title.slice(14);
  } else if (title.slice(0, 3) === "M&B") {
    titleSplit.innerText = title.slice(0, 3);
    titleMain.innerText = title.slice(3);
  } else if (title.slice(0, 11) === "Malt & Brew") {
    titleSplit.innerText = title.slice(0, 11);
    titleMain.innerText = title.slice(11);
  } else {
    titleSplit.style.display = "none";
  }
}

// floating add to cart
const floatingButton = document.querySelector(".product__floating-button");
const productInfo = document.querySelector(".product");
const footer = document.querySelector("footer");

const productScrollOptions = {
  rootMargin: "-300px 0px 0px 0px",
};

const productScrollObserver = new IntersectionObserver((items) => {
  var intersecting = false;
  items.forEach((item) => {
    if (item.isIntersecting) {
      intersecting = true;
    }
  });

  if (!intersecting) {
    floatingButton?.classList.add("active");
  } else if (floatingButton?.classList.contains("active")) {
    floatingButton?.classList.remove("active");
  }
}, productScrollOptions);

if (productInfo) {
  productScrollObserver.observe(productInfo);
}

if (footer) {
  productScrollObserver.observe(footer);
}
